import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-content-actions',
    templateUrl: './content-actions.component.html',
    styleUrls: ['./content-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentActionsComponent implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
